// Contact form handling

function generateCaptcha() {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const operators = ['+', '-'];
    const operator = operators[Math.floor(Math.random() * operators.length)];
    
    let answer;
    if (operator === '+') {
        answer = num1 + num2;
    } else {
        answer = num1 - num2;
    }
    
    return {
        question: `${num1} ${operator} ${num2}`,
        answer: answer.toString()
    };
}

export function initContactForm() {
    const form = document.getElementById('contactForm');
    if (!form) return;

    // Initialize CAPTCHA
    const captcha = generateCaptcha();
    const captchaQuestion = document.getElementById('captchaQuestion');
    const captchaAnswer = document.getElementById('captchaAnswer');
    if (captchaQuestion && captchaAnswer) {
        captchaQuestion.textContent = captcha.question + ' =';
        captchaAnswer.value = captcha.answer;
    }

    const messagesDiv = form.querySelector('.form-messages');
    const submitButton = form.querySelector('.submit-btn');

    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Clear previous errors
        clearErrors();
        clearMessages();

        // Get form data
        const formData = {
            firstName: form.firstName.value,
            lastName: form.lastName.value,
            email: form.email.value,
            message: form.message.value,
            captcha: form.captcha.value,
            captchaAnswer: form.captchaAnswer.value
        };

        // Disable submit button
        submitButton.disabled = true;
        submitButton.textContent = 'Sending...';

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (result.success) {
                // Show success message
                showMessage(result.message, 'success');
                
                // Reset form
                form.reset();
                
                // Regenerate CAPTCHA
                const newCaptcha = generateCaptcha();
                const captchaQuestion = document.getElementById('captchaQuestion');
                const captchaAnswer = document.getElementById('captchaAnswer');
                if (captchaQuestion && captchaAnswer) {
                    captchaQuestion.textContent = newCaptcha.question + ' =';
                    captchaAnswer.value = newCaptcha.answer;
                }
            } else {
                // Show validation errors
                if (result.errors) {
                    displayErrors(result.errors);
                }
                
                // Show error message
                showMessage(result.message || 'Please fix the errors above', 'error');
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            showMessage('An error occurred. Please try again later.', 'error');
        } finally {
            // Re-enable submit button
            submitButton.disabled = false;
            submitButton.textContent = 'Send Message';
        }
    });

    function clearErrors() {
        const errorElements = form.querySelectorAll('.field-error');
        errorElements.forEach(el => {
            el.textContent = '';
            el.style.display = 'none';
        });

        const fields = form.querySelectorAll('.field');
        fields.forEach(field => field.classList.remove('has-error'));
    }

    function displayErrors(errors) {
        Object.keys(errors).forEach(fieldName => {
            const input = form.querySelector(`[name="${fieldName}"]`);
            if (input) {
                const field = input.closest('.field');
                const errorSpan = field.querySelector('.field-error');
                
                if (errorSpan) {
                    errorSpan.textContent = errors[fieldName];
                    errorSpan.style.display = 'block';
                    field.classList.add('has-error');
                }
            }
        });
    }

    function clearMessages() {
        messagesDiv.textContent = '';
        messagesDiv.className = 'form-messages';
    }

    function showMessage(message, type) {
        messagesDiv.textContent = message;
        messagesDiv.className = `form-messages ${type}`;
        
        // Scroll to message
        messagesDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}
